import request from '@/plugin/axios'

// 根据parentId查询字典表
export function GetDict (data) {
  return request({
    url: '/airsense/api/airsenseDict/getDictInfo',
    method: 'get',
    params: request.adornParams(data, false)
  })
}

// 修改密码
export function ChangePwd (data) {
  return request({
    url: '/sys/user/password',
    method: 'post',
    data: request.adornData(data)
  })
}

// 获取用户角色
export function GetRole (data) {
  return request({
    url: '/sys/role/select',
    method: 'get',
    params: request.adornParams(data)
  })
}

// 获取菜单
export function GetMenu (data) {
  return request({
    url: '/sys/menu/nav',
    method: 'get',
    params: request.adornParams(data)
  })
}

// 根据map查询userList
export function QueryUserListByMap (data) {
  return request({
    url: '/sys/user/queryUserListByMap',
    method: 'post',
    data: data
  })
}
// 根据map查询userList
export function QueryUserListByMobile (data) {
  return request({
    url: '/sys/user/userInfoByPhone',
    method: 'post',
    data: data
  })
}

// 获取临时token
export function GetTempToken (data) {
  return request({
    url: '/airsense/api/token/generateToken',
    method: 'post',
    params: request.adornParams(data)
  })
}

// 获取短信验证码
export function GetPhoneCode (data) {
  return request({
    url: '/platform/api/mobile/code',
    method: 'get',
    params: request.adornParams(data)
  })
}

// 验证短信验证码
export function CheckPhoneCode (data) {
  return request({
    url: '/platform/api/mobile/checkSMS',
    method: 'get',
    params: request.adornParams(data)
  })
}

// 获取城市地区信息
export function GetProvinceCityAreaInfo (data) {
  return request({
    url: '/airsense/api/chinaArea/getProvinceCityAreaInfo',
    method: 'get',
    params: request.adornParams(data)
  })
}

export function GetCodeNameInfo (data) {
  return request({
    url: '/airsense/api/chinaArea/getCodeNameInfo',
    method: 'get',
    params: request.adornParams(data)
  })
}

// 获取管路型号接口
export function GetPipelineModeInfo () {
  return request({
    url: '/airsense/api/airsensePipelineMode/getPipelineModeInfo',
    method: 'post'
  })
}

// 获取面罩型号接口
export function GetMaskModeInfo (data) {
  return request({
    url: '/airsense/api/airsenseMaskMode/getMaskModeInfo',
    method: 'post',
    params: request.adornParams(data)
  })
}

// 获取设备型号接口
export function GetDeviceInfo () {
  return request({
    url: '/airsense/api/airsenseDeviceMode/getDeviceModeInfo',
    method: 'post'
  })
}

// 根据DN检验SN码
export function CheckDeviceSN (data) {
  return request({
    url: '/platform/airsenseDeviceInformation/checkDeviceSN',
    method: 'post',
    data: request.adornParams(data, false)
  })
}

// 获取医院或科室接口
export function GetHospitalRoomInfo (data) {
  return request({
    url: '/airsense/api/airsenseHospitalInformation/getHospitalInfo',
    method: 'get',
    params: request.adornParams(data, false)
  })
}

// 获取隐私协议接口
export function GetPrivacyAgreement (data) {
  return request({
    url: process.env.VUE_APP_API + '/platform/airsensePatient/downloadPrivacyAgreement',
    method: 'get',
    params: request.adornParams(data),
    responseType: 'blob'
  })
}
